"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_redux_1 = require("react-redux");
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
const useAppDispatch = react_redux_1.useDispatch;
const dispatchFunction = async ({ action, onSuccess, onError, dispatch, }) => {
    const dispatchCall = await dispatch(action);
    const isFullfilled = (0, lodash_get_1.default)(dispatchCall, 'meta.requestStatus', '') === 'fulfilled';
    const dispatchPayload = (0, lodash_get_1.default)(dispatchCall, 'payload', '');
    if (isFullfilled) {
        onSuccess && onSuccess(dispatchPayload);
    }
    if (!isFullfilled) {
        onError && onError(dispatchPayload);
    }
};
function useAsyncAppDispatch() {
    const dispatch = useAppDispatch();
    return (props) => dispatchFunction({ dispatch, ...props });
}
exports.default = useAsyncAppDispatch;
//# sourceMappingURL=asyncAppDispatch.js.map